import React from "react";
import "./style.css";
import { CourseLandingLoop } from "../CourseLandingLoop";
import { CourseLandingViewMore } from "../CourseLandingViewMore";

export const CourseLandingContentSection = ({
  title,
  is_new,
  is_updated,
  loop,
  loop_text,
  text,
  expanded_text,
  number,
  language
}) => {

    let translations = {
      "new": {
        "en": "New!",
        "es": "¡Nuevo!",
        "pt": "Novo!",
        "fr": "Nouveau!"
      },
      "updated": {
        "en": "Updated!",
        "es": "Actualizado!",
        "pt": "¡Atualizado!",
        "fr": "Mis à jour!"
      }
    };

  return (
    <div className="course_landing_course_content_section">
      <div className="course_landing_course_content_number"><span>{number}</span></div>
      <h3 className="course_landing_course_content_title">
        <span className="align-middle">{title}</span>
        {
          is_new ?
            <span className="align-middle landing_content_title_chip">{translations["new"][language]}</span>
            :
            <>
            </>
        }
        {
          is_updated ?
            <span className="align-middle landing_content_title_chip">{translations["updated"][language]}</span>
            :
            <>
            </>
        }
      </h3>
      <CourseLandingLoop loop={loop} text={loop_text ? loop_text : ""} />
      <CourseLandingViewMore language={language} text={text} expanded_text={expanded_text} />
    </div>
  );
};
